import React from 'react';
import { registerWidget } from '@okapi/core';
import { BannerWidget } from 'entries/common/widgets';
import type { BannerFeatureProps, BannerResponse, StretchBannerFeatureProps } from 'features/banner/types';
import { fetchApiClient } from 'api/fetch-api-client/fetch-api-client';
import { impressionClickTracking, impressionViewTracking } from 'api/fetch-api-client/tracking';
import { EnvState } from 'api/fetch-api-client/types';

registerWidget<BannerResponse & EnvState, BannerFeatureProps & StretchBannerFeatureProps>(
  `${__NAME__}/banner`,
  serverData => {
    return props => {
      if (!serverData.env) {
        return <BannerWidget {...props} banners={serverData} />;
      }

      const contentIdClicked: string[] = [];

      const { env } = serverData;

      if (env) {
        fetchApiClient.setHost(serverData.env.host);
        fetchApiClient.addDefaultHeader('x-api-key', serverData.env.apiKey);
      }

      const onImpressionContentClick = (bannerId: string) => {
        if (!contentIdClicked.includes(bannerId)) {
          impressionClickTracking(bannerId);
        }

        contentIdClicked.push(bannerId);
      };

      const onImpressionContentView = (bannerId: string) => {
        impressionViewTracking(bannerId);
      };

      return (
        <BannerWidget
          {...props}
          banners={serverData}
          onImpressionContentClick={onImpressionContentClick}
          onImpressionContentView={onImpressionContentView}
        />
      );
    };
  }
);
